export class FindNyukyoshaResult {
    userCd = -1;
    nyukyokeiyakuNo = -1;
    userName = "";
    nyukyoshaName = "";
    buknCd = -1;
    buknName = "";
    roomNo = "";
    unconfirmedFlag = false;
    jokyoKb = -1;
}
